export default {
  title: 'Itens mais vendidos',
  columns: {
    name: 'Nome',
    quantity: 'Quantidade',
    amount: 'Valor',
  },
};
